import React from 'react';
import classNames from "classnames";
import styled from "styled-components";

export interface SectionTitleProps {
    className?: string;
    title: string;
    caption?: string;
}

export function SectionTitle(props: SectionTitleProps) {
    return (
        <Root className={classNames("title has-text-centered", props.className)}>
            <span className="is-family-secondary">{props.caption}</span>
            {props.title}
        </Root>
    )
}

const Root = styled.h1``;